import styled from 'styled-components';
import { Styling } from '../../../../constants';

export const SportSelectClass = 'SportSelector';

export const SportSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  text-align: center;
  .${SportSelectClass} {
    width: 160px;
  }
`;
